import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "conflict.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M15.7303 6.49496C15.6552 6.35521 15.509 6.2687 15.3504 6.26996H11.7205L13.6155 1.60507L13.6154 1.60494C13.6705 1.47009 13.6556 1.31679 13.5755 1.19499C13.4926 1.07471 13.3565 1.00201 13.2105 1H7.86033C7.68203 1.00126 7.52218 1.10974 7.45526 1.27497L4.24525 9.17504V9.17517C4.18938 9.31052 4.20633 9.46508 4.29033 9.58511C4.3688 9.70766 4.50478 9.78136 4.6503 9.78011H9.44536L7.43531 18.46C7.38509 18.6681 7.49307 18.882 7.69032 18.965C7.74381 18.9886 7.80182 19.0005 7.86033 19C8.011 19.001 8.15124 18.9233 8.23035 18.7949L15.7203 6.94003C15.8058 6.80505 15.8097 6.63367 15.7302 6.49504L15.7303 6.49496Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }